import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import RadioTableGroup from 'components/Common/Inputs/RadioTableGroup';
import ModalWrapper from 'components/Modals/ModalWrapper';

class EditLinkedCustomerModalForm extends Component {
  static propTypes = {
    onConfirmCustomerLink: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    currentForm: PropTypes.shape()
  };

  static defaultProps = {
    currentForm: null
  };

  constructor(props) {
    super(props);
    this.state = {
      isRequestingEditLinkedCustomer: false,
      createTempCustomer: false,
      customer: null
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onCustomerIdSelectedItem = lookupValue => lookupValue && this.setState({ customer: lookupValue });

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    const { customer, createTempCustomer } = this.state;
    const { onConfirmCustomerLink } = this.props;

    if (!customer && !createTempCustomer) {
      toastr.error('', 'Please provide Customer Id');
      return;
    }

    if (!createTempCustomer && (!customer.id || customer.id <= 0)) {
      toastr.error('', 'Please reselect the customer to link the form to');
      this.setState({ customer: null });
      return;
    }

    onConfirmCustomerLink(createTempCustomer ? -9999 : customer.id);
  }

  render() {
    const { onCancel, isShown, currentForm } = this.props;
    const { customer, isRequestingEditLinkedCustomer, createTempCustomer } = this.state;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Edit Customer Linked to Form"
        btnConfirmTitle="Confirm Change"
        btnConfirmClass={ `btn-danger ${ isRequestingEditLinkedCustomer ? 'loading' : '' }` }
        btnCancelTitle="Cancel"
        onConfirm={ this.handleSubmit }
        onCancel={ onCancel }
        modalSize="edit-linked-customer-modal"
      >

        <form id="editLinkedCustomerForm" name="editLinkedCustomerForm" className="form-horizontal edit-linked-customer-modal" onSubmit={ this.handleSubmit }>
          <div className="form-group">
            <p>Edit the customer associated with this form</p>
          </div>
          <div className="form-group">
            <div className="col-3">
              Form Type
            </div>
            <div className="col-9 bold">
              { currentForm && <React.Fragment>{ currentForm.formType } { currentForm.entityName && <React.Fragment> - { currentForm.entityName }</React.Fragment> }</React.Fragment> }
            </div>
          </div>
          <div className="form-group">
            <div className="col-3">
              Assigned Customer
            </div>
            <div className="col-9 bold">
              { currentForm && currentForm.customerId }{ currentForm.customerName && <React.Fragment> / { currentForm.customerName }</React.Fragment> }
              { currentForm && !currentForm.customerId && <p>None</p> }
            </div>
          </div>
          <div className="separator">
            <hr size="1" />
            <p>To change the customer linked to the form, please choose from the options below</p>
          </div>
          <div className="form-group">
            <div className="col-12">
              <RadioTableGroup
                name="createTempCustomer"
                items={ [[{ text: 'Find Existing Customer', value: 'false', defaultChecked: true }, { text: 'Remove Assigned Customer', value: 'true' }]] }
                preventReset
                onChange={ (e, newVal) => this.setState({ createTempCustomer: newVal === 'true' }) }
              />
            </div>
          </div>
          { !createTempCustomer && <div className="form-group">
            <div className="col-3">
              <label htmlFor="customer-id" className="panel-body-label">
                Customer ID
              </label>
            </div>
            <div className="col-9">
              <AutoCompleteInput
                id="customer-id"
                name="customerId"
                category="customer"
                placeholder="Enter customer id..."
                className="form-select"
                required
                value={ customer || '' }
                onSelectedItem={ lookupValue => this.onCustomerIdSelectedItem(lookupValue) }
              />
            </div>
          </div> }
          { createTempCustomer && <div className="form-group mt-2">
            <p>A new temporary customer will be created without a legal entity assigned</p>
          </div> }
        </form>
      </ModalWrapper>
    );
  }
}

const EditLinkedCustomerModalReduxForm = reduxForm({
  form: 'editLinkedCustomerForm'
})(EditLinkedCustomerModalForm);

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    forms: {
      isRequestingEditLinkedCustomer,
      currentForm
    }
  } = state;

  return {
    isRequestingEditLinkedCustomer,
    currentForm
  };
}

export const EditLinkedCustomrModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditLinkedCustomerModalReduxForm);

export default EditLinkedCustomrModal;
